<template>
    <button class="EvieChatLandingPrompt" type="button" @click="$emit('click')">
        <span class="EvieChatLandingPrompt__iconBox" :style="{ background: iconBg }">
            <EidIcon class="EvieChatLandingPrompt__icon" :icon-src="icon" :style="{ color: iconColor }" />
        </span>
        <span class="EvieChatLandingPrompt__text">{{ prompt }}</span>
    </button>
</template>

<style lang="scss">
.EvieChatLandingPrompt {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    padding: 14px 18px;
    background: var(--eidWhite);
    border: 1px solid var(--eidSecureBlue-10);
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;

    &:hover {
        border-color: var(--eidTrustGreen);
        background: var(--eidTrustGreen-10);
    }

    &__iconBox {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border-radius: 6px;
    }

    &__icon {
        font-size: 12px;
    }

    &__text {
        font-size: 14px;
        color: var(--eidQualityBlack);
        line-height: 1.4;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    export default defineComponent({
        name: 'EvieChatLandingPrompt',
        components: { EidIcon },
        props: {
            prompt: { type: String, required: true },
            icon: { type: Object as PropType<IconDefinition>, required: true },
            iconColor: { type: String, default: 'inherit' },
            iconBg: { type: String, default: 'transparent' },
        },
        emits: [ 'click' ],
    });
</script>
